<template>
  <detail
    :data="data"
    :onManager="onManager"
    :base-info="baseInfo"
    :nameRules="nameRules" />
</template>

<script>
import i18n from '@/locales'
import {
  getEnabledTableColumn,
} from '@/utils/common/tableColumn'
import DimensionMixin from '../mixins/dimension'

export default {
  name: 'ProjectMappingDetail',
  mixins: [DimensionMixin],
  props: {
    data: {
      type: Object,
      required: true,
    },
    onManager: {
      type: Function,
      required: true,
    },
  },
  data () {
    return {
      baseInfo: [
        getEnabledTableColumn(),
        {
          title: i18n.t('bill.text_288'),
          field: 'dimension_type',
          slots: {
            default: ({ row }) => {
              return this.dimensionTypeList.filter(item => row.dimension_type === item.value)[0].key
            },
          },
        },
        {
          title: i18n.t('bill.text_289'),
          field: 'dimension_items',
          slots: {
            default: ({ row }) => {
              if (!row.dimension_items) return '-'
              return <a onClick={ () => this.$emit('tab-change', 'dimension-item-list') }>{row.dimension_items.length}</a>
            },
          },
        },
      ],
      nameRules: [
        { required: true, message: this.$t('bill.text_145') },
        { max: 256, message: this.$t('validator.maxLength', ['256']) },
      ],
    }
  },
  computed: {
  },
}
</script>
